import script from "./reset-password.vue?vue&type=script&setup=true&lang=js"
export * from "./reset-password.vue?vue&type=script&setup=true&lang=js"

import "./reset-password.vue?vue&type=style&index=0&id=4654c74a&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4654c74a"]])

export default __exports__